import getVisitorId from 'mex_components/app/scripts/storage/getVisitorId';
import getClientId from 'mex_components/app/scripts/storage/getClientId';


const pickListButtonTracking = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'buybox_picklistButton',
    picklist_button_text: data.innerText,
    visitor_id: getVisitorId(),
    client_id: getClientId()
  });
};


export default function (){
  const subscriptonFilter = document.querySelector('.buy-box-subscription-filter');
  var btn = subscriptonFilter.querySelector('button');
  btn.addEventListener('click', () => pickListButtonTracking(btn));
}
